import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 需量接口
 **********************************************************************************/
export default {
	/**
	 * 检查变量是否是需要计算的逻辑需量，如果是就返回它的对象
	 */
	checkVariableIsCalculate(ids, success, failure) {
		Axios.post('/demand/checkVariableIsCalculate.do', {
			ids
		}, success, failure)
	},
	/**
	 * 为一个需量变量增加计算服务
	 */
	addCalculateDemand(pkid, includes, success, failure) {
		Axios.post('/demand/addCalculateDemand.do', {
			pkid,
			includes
		}, success, failure)
	},
	/**
	 * 为一个需量变量增加计算服务
	 */
	deleteCalculateDemand(pkid, success, failure) {
		Axios.post('/demand/deleteCalculateDemand.do', {
			pkid
		}, success, failure)
	}
}
